// Implements: F-UIX-018, F-OBS-005, F-OBS-011
/**
 * `/backoffice/audit` — "Auditoría" (UIX.7): the audit trail of each organization the person
 * administers, filtered and paginated.
 *
 * The page only composes: the targets, the reads, the filters and the rows live in the
 * `backoffice` module's `AuditByOrganization`, which keys each organization's container by its id
 * (checklist 14). It is keyed here by the person as well, so another person signing in on the
 * same tab never inherits the previous one's choice, filters or pages.
 */

import type { ReactElement } from "react";

import { AuditByOrganization } from "../../modules/backoffice/containers/AuditContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function AuditPage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("backoffice.audit.title")} subtitle={t("backoffice.audit.intro")} />
      <AuditByOrganization key={user.id} scopes={scopes} />
    </section>
  );
}
